(() => {
  const ROOT_SELECTOR = '#ProductGridContainer';

  class AurumInfiniteCollection {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('#product-grid');
      this.sentinel = root.querySelector('[data-infinite-sentinel]');
      this.status = root.querySelector('[data-infinite-status]');
      this.loading = false;
      this.observer = null;
      this.init();
    }

    getNextUrl() {
      const next = this.root.querySelector('[data-infinite-pagination] a[aria-label*="Next" i], [data-infinite-pagination] .pagination__item--prev');
      return next ? next.href : null;
    }

    init() {
      if (!this.grid || !this.sentinel || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '700px 0px 700px 0px' });
      this.observer.observe(this.sentinel);
    }

    async loadNext() {
      if (this.loading) return;
      const nextUrl = this.getNextUrl();
      if (!nextUrl) {
        this.finish();
        return;
      }
      this.loading = true;
      if (this.status) this.status.textContent = 'Loading more pieces…';
      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Unable to load the next collection page.');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = doc.querySelector('#product-grid');
        const incomingPagination = doc.querySelector('[data-infinite-pagination]');
        if (!incomingGrid) throw new Error('Product grid not found.');

        const fragment = document.createDocumentFragment();
        [...incomingGrid.children].forEach((item) => fragment.appendChild(item));
        this.grid.appendChild(fragment);

        const currentPagination = this.root.querySelector('[data-infinite-pagination]');
        if (currentPagination) {
          if (incomingPagination) currentPagination.innerHTML = incomingPagination.innerHTML;
          else currentPagination.remove();
        }

        document.dispatchEvent(new CustomEvent('aurum:collection-appended', { detail: { root: this.root } }));
        if (this.status) this.status.textContent = '';
        if (!this.getNextUrl()) this.finish();
      } catch (error) {
        console.warn('[Aurum Deorum] Infinite collection loading:', error);
        if (this.status) this.status.textContent = 'More pieces could not be loaded automatically. Scroll a little and try again.';
      } finally {
        this.loading = false;
      }
    }

    finish() {
      if (this.observer) this.observer.disconnect();
      if (this.sentinel) this.sentinel.remove();
      if (this.status) this.status.textContent = '';
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
    }
  }

  let instance = null;
  const boot = () => {
    if (instance) instance.destroy();
    const root = document.querySelector(ROOT_SELECTOR);
    instance = root ? new AurumInfiniteCollection(root) : null;
  };

  boot();

  // Dawn replaces ProductGridContainer when filters/sorting are changed.
  const pageObserver = new MutationObserver(() => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (root && (!instance || instance.root !== root)) boot();
  });
  pageObserver.observe(document.body, { childList: true, subtree: true });
})();
